import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Patient } from '../models/patient';
import { PatientService } from '../services/patient.service';

import { RestService } from '../services/rest.service';
import { InvoiceService } from '../services/invoice.service';
import { Invoice } from '../models/invoice';
import { BaseTable } from '../shared/base-table';
import { LoginService } from '../services/login.service';
import { DatePipe } from '@angular/common';
@Component({
  selector: 'qmed-invoice',
  templateUrl: '../shared/base-table.html',
  styleUrls: ['../shared/base-table.css'],
  encapsulation: ViewEncapsulation.None
})
export class InvoiceComponent extends BaseTable implements OnInit {
  public columns: Array<any> = [
    {
      title: 'Nr. factura',
      name: 'documentSerie',
      sort: true
    },
    {
      title: 'Data',
      name: 'date',
      sort: true,
      type: 'date'
    },
    { title: 'Suma', name: 'total', sort: true },
    { title: 'Factura', name: 'invoiceFileUrl', sort: true }
  ];

  public config: any = {
    paging: true,
    sorting: { columns: this.columns },
    filtering: { filterString: '' },
    className: ['table-striped', 'table-bordered']
  };
  loading: boolean;

  public constructor(
    private restService: RestService,
    private invoiceService: InvoiceService,
    private loginService: LoginService
  ) {
    super();
    this.loading = true;
  }

  public ngOnInit(): void {
    this.tableTitle = 'Facturi';
    this.invoiceService.getAll().subscribe(res => {
      // This is needed to convert the apritude file into a link/button etc
      this.data = res.map(
        this.convertInvoiceFileDataToDownloadButton.bind(
          null,
          this.loginService.getUserToken()
        )
      );
      this.length = this.data.length;

      this.onChangeTable(this.config);
      this.loading = false;
    }, err => (this.loading = false));
  }

  convertInvoiceFileDataToDownloadButton(token: String, invoice: Invoice) {
    const link =
      invoice.invoiceFileUrl == null
        ? '<span class="glyphicon glyphicon-ban-circle"></span> Nu este factura'
        : `<a class="btn btn-primary btn-danger" target="_blank" href="${
            RestService.BASE_URL
          }${invoice.invoiceFileUrl}?token=${token}">
            <span class="glyphicon glyphicon-download"></span> Descarca factura</a>`;
    const dateString = invoice.date;

    let formatedDateString = '';
    if (dateString != null || dateString !== undefined) {
      const datePipe = new DatePipe('en');
      formatedDateString = datePipe.transform(dateString, 'dd-MM-yyyy');
    }
    return new Invoice(
      invoice.documentSerie,
      invoice.base,
      invoice.vat,
      link,
      invoice.total,
      formatedDateString
    );
  }
}



// WEBPACK FOOTER //
// /home/usr/clienti.qmedical/src/app/invoice/invoice.component.ts